<div class="column roulette-items-wrapper">
    <div class="roulette-item-container" *ngFor="let roulette of roulettes$ | async">
        <div class="roulette-header">{{roulette.Name}}</div>

        <div class="row roulette-content">
                <button class="img-button">
                    <img class="roulette-img" [src]="roulette.SpinnerThumbUrl" (click)="viewRoulette(roulette)" />
                </button>
                    <div class="column">

                        <div class="data-row row">
                            <span class="title">{{'ROULETTE.ROUNDS' | translate}}</span>
                            <span dir="ltr" class="data"
                                [ngClass]="{'spinsLimit':roulette.SpinsCountInPackage && roulette.ActualSpinsCount>=roulette.SpinsCountInPackage}">
                                <span>{{roulette.ActualSpinsCount}}</span>
                                <span *ngIf="roulette.SpinsCountInPackage>0">/{{roulette.SpinsCountInPackage}}</span>
                            </span>
                        </div>
                        <div class="data-row row">
                            <span class="title">{{'ROULETTE.LIDS' | translate}}</span>
                            <span class="data">{{roulette.ActualRouletteLids}}</span>
                        </div>
                        <div class="data-row row">
                            <span class="title">{{'ROULETTE.VIEWS' | translate}}</span>
                            <span class="data">{{roulette.ActualViewsCount}}</span>
                        </div>
                        <div class="data-row row">
                            <span class="title">{{'ROULETTE.STATUS' | translate}}</span>
                            <span class="data" [ngClass]="roulette.Status===WebRouletteStatus.purched||roulette.Status===WebRouletteStatus.purchedNotLimitPackage
            ||roulette.Status===WebRouletteStatus.purchedFreePackage?'available':'notAvailable'">
                                {{roulette.Status|enumTranslate:WebRouletteStatus}}</span>
                            <span class=" data notAvailable"
                                *ngIf="roulette.Status===WebRouletteStatus.spinsLimit||roulette.Status===WebRouletteStatus.spinsLimitForFreePackage">
                                {{'MY_ROULETTES.LIMITֹ_SPINS' | translate}}</span>
                        </div>
                        <div class="data-row row">
                            <span class="title">{{'ROULETTE.EXPIRY' | translate}}</span>
                            <span class="data"
                                [ngClass]="{'expire':roulette.Status===WebRouletteStatus.expired}">{{roulette.ExpireDescription}}</span>
                        </div>
                    </div>

                    <div class="buttons-container column">
                        <button class="command-button full" *ngIf="isAllowedChangePackage(roulette)"
                            (click)="changePackage(roulette)">{{getChangePackageText(roulette)}}</button>
                        <button class="command-button full"
                            *ngIf="roulette.Status===WebRouletteStatus.purchedButNotAvailable"
                            (click)="changeToAvailable(roulette)">{{'ROULETTE.FREE_OPERATION' | translate}}</button>
                        <button class="command-button full"
                            *ngIf="roulette.Status===WebRouletteStatus.notPurched || roulette.Status===WebRouletteStatus.expired"
                            (click)="delete(roulette)">{{'ROULETTE.DELETE' | translate}}</button>
                    </div>
            </div>
        <div class="roulette-footer" *ngIf="roulette.RouletteLink">
            <div class="link-with-copy row">
                <button class="copy" pTooltip="{{'ROULETTE.COPY'|translate}}"
                    [copyToClipboard]="roulette.RouletteLink"><i class="pi pi-copy"></i></button>
                <span class="link"><a target="_blank" rel="noopener noreferrer"
                        href="{{roulette.RouletteLink}}">{{roulette.RouletteLink}}</a></span>
            </div>
        </div>

    </div>
    <div class="roulette-item-container new row">
        <a href="/roulette" class="new-roulette column">
            <i class="pi pi-plus-circle"></i>
            <span>{{'ROULETTE.NEW_ROULETTE' | translate}}</span>
        </a>
    </div>
</div>